import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Table, Select, InputNumber } from "antd";
import DetailTable from './DetailTable';
import moment from "moment"

function TableWidget(props) {
    const [isBusy, setIsBusy] = useState(false);
    const { dataList, setDataList } = props;

    if (dataList === undefined) return <div />

    const columns = [
        {
            title: "ID",
            dataIndex: "id",
            render: (text, record) => {
                return <div>{moment(text).format("YYYY-MM")} &nbsp; (${record.expense})</div>;
            }
        }
    ];
    const dataSource = dataList.map((info) => {
        return { ...info, key: info.id };
    });

    return (
        <div className="list-table">
            <Table
                showHeader={false}
                pagination={false}
                columns={columns}
                dataSource={dataSource}
                expandedRowRender={record => {
                    return <DetailTable
                        dataList={record.items} />
                }}
            />
        </div>
    )
}

export default withRouter(TableWidget)
